import Toast from 'react-native-toast-message'
import { v4 as uuidv4 } from 'uuid'

interface ToastProps {
  type: 'success' | 'error' | 'warn' | 'info'
  text1?: string
  text2?: string
  position?: 'top' | 'bottom'
  visibilityTime?: number
  autoHide?: boolean
  topOffset?: number
  bottomOffset?: number
  keyboardOffset?: number
  onShow?: () => void
  onHide?: () => void
  onPress?: () => void
  noWrapSubtitle?: boolean
  v2?: boolean
  action?: () => void
  actionText?: string
  isImportant?: boolean
  props?: any
}

const show = (toastData: ToastProps) => {
  Toast.show(toastData)
}

export const error = (
  title: string,
  subtitle: string,
  noWrapSubtitle?: boolean,
  options?: Omit<ToastProps, 'type'>,
  v2?: boolean,
  position?: 'top' | 'bottom',
  action?: () => void,
  actionText?: string,
  isImportant?: boolean,
  emoji?: string,
  icon?: React.ReactNode,
) => {
  show({
    type: 'error',
    text1: title,
    text2: subtitle,
    props: { noWrapSubtitle, v2, action, actionText, isImportant, id: uuidv4(), emoji, icon },
    position,
    visibilityTime: v2 && action ? 3000 : undefined,
    ...options,
  })
}

export const warn = (
  title: string,
  subtitle: string,
  noWrapSubtitle?: boolean,
  options?: Omit<ToastProps, 'type'>,
  v2?: boolean,
  position?: 'top' | 'bottom',
  action?: () => void,
  actionText?: string,
  isImportant?: boolean,
  emoji?: string,
  icon?: React.ReactNode,
) => {
  show({
    type: 'warn',
    text1: title,
    text2: subtitle,
    props: { noWrapSubtitle, v2, action, actionText, isImportant, id: uuidv4(), emoji, icon },
    position,
    visibilityTime: v2 && action ? 3000 : undefined,
    ...options,
  })
}

export const info = (
  title: string,
  subtitle?: string,
  noWrapSubtitle?: boolean,
  options?: Omit<ToastProps, 'type'>,
  v2?: boolean,
  position?: 'top' | 'bottom',
  action?: () => void,
  actionText?: string,
  isImportant?: boolean,
  emoji?: string,
  icon?: React.ReactNode,
) => {
  show({
    type: 'info',
    text1: title,
    text2: subtitle,
    props: { noWrapSubtitle, v2, action, actionText, isImportant, id: uuidv4(), emoji, icon },
    position,
    visibilityTime: v2 && action ? 3000 : undefined,
    ...options,
  })
}

export const success = (
  title: string,
  subtitle: string,
  noWrapSubtitle?: boolean,
  options?: Omit<ToastProps, 'type'>,
  v2?: boolean,
  position?: 'top' | 'bottom',
  action?: () => void,
  actionText?: string,
  isImportant?: boolean,
  emoji?: string,
  icon?: React.ReactNode,
) => {
  show({
    type: 'success',
    text1: title,
    text2: subtitle,
    props: { noWrapSubtitle, v2, action, actionText, isImportant, id: uuidv4(), emoji, icon },
    position,
    visibilityTime: v2 && action ? 3000 : undefined,
    ...options,
  })
}

export const hide = () => {
  Toast.hide()
}
